import { render } from "./JzNav.vue?vue&type=template&id=b11afb68&scoped=true"
import script from "./JzNav.vue?vue&type=script&lang=js"
export * from "./JzNav.vue?vue&type=script&lang=js"

import "./JzNav.vue?vue&type=style&index=0&id=b11afb68&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b11afb68"]])

export default __exports__